<template>
  <v-dialog hide-overlay max-width="1500px" v-model="show">
    <v-card>
      <v-card-title>模拟SA冲突</v-card-title>
      <v-card-actions>
        <v-btn @click="save">{{$t('app.buttons.save')}}</v-btn>
        <v-btn @click="remove">削除</v-btn>
        <v-btn @click="cancel">{{$t('app.buttons.back')}}</v-btn>
      </v-card-actions>
    </v-card>
    <v-data-table
      :headers="displayHeaders"
      :items="shipment.packages"
      :rows-per-page-items="[10]"
      class="inline-edit"
      item-key="seq"
      key="fcl"
      select-all
      v-model="selected"
    >
      <template slot="items" slot-scope="props">
        <tr>
          <td>
            <v-checkbox hide-details primary v-model="props.selected"/>
          </td>
          <td key="containerNo" v-if="isSeaFcl">
            <v-text-field
              :placeholder="$t('app.labels.package.containerNo')"
              v-model="props.item.containerNo"
            />
          </td>
          <td key="containerTypeId" v-if="isSeaFcl">
            <remote-autocomplete
              :placeholder="$t('app.labels.package.containerSize')"
              url="container-types/kv"
              v-model="props.item.containerTypeId"
            />
          </td>
          <td>{{ props.item.invoiceNo }}</td>
          <td>{{ props.item.skuCode }}</td>
          <td>{{ props.item.lotNo }}</td>
          <td>{{ props.item.poNo }}</td>
          <td>
            <v-text-field
              :placeholder="$t('app.labels.package.totalQty')"
              @change="calQty(props.item)"
              class="input-number"
              type="number"
              v-model="props.item.totalQty"
            />
          </td>
          <td>
            <v-text-field :placeholder="$t('app.labels.package.flag')" v-model="props.item.flag"/>
          </td>
          <td>
            <v-text-field
              :placeholder="$t('app.labels.package.cartonStartNo')"
              @change="calQty(props.item)"
              type="number"
              v-model="props.item.cartonStartNo"
            />
          </td>
          <td>
            <v-text-field
              :placeholder="$t('app.labels.package.cartonEndNo')"
              @change="calQty(props.item)"
              type="number"
              v-model="props.item.cartonEndNo"
            />
          </td>
          <td>
            <v-text-field
              :placeholder="$t('app.labels.package.shippedCarton')"
              type="number"
              v-model="props.item.shippedCarton"
            />
          </td>
          <td>
            <v-text-field
              :placeholder="$t('app.labels.package.perCartonQty')"
              type="number"
              v-model="props.item.perCartonQty"
            />
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      sa: {},
      headers: [
        {
          text: this.$t('app.labels.package.containerNo'),
          value: 'containerNo',
          sortable: false
        },
        {
          text: this.$t('app.labels.package.containerSize'),
          value: 'containerSize',
          sortable: false
        },
        {
          text: this.$t('app.labels.ivNo'),
          value: 'invoiceNo',
          sortable: false
        },
        {
          text: this.$t('app.labels.skuCode'),
          value: 'skuCode',
          sortable: false
        },
        { text: this.$t('app.labels.lotNo'), value: 'lotNo', sortable: false },
        { text: this.$t('app.labels.poNo'), value: 'poNo', sortable: false },
        {
          text: this.$t('app.labels.package.totalQty'),
          value: 'totalQty',
          sortable: false
        },
        {
          text: this.$t('app.labels.package.flag'),
          value: 'flag',
          sortable: false
        },
        {
          text: this.$t('app.labels.package.cartonStartNo'),
          value: 'cartonStartNo',
          sortable: false
        },
        {
          text: this.$t('app.labels.package.cartonEndNo'),
          value: 'cartonEndNo',
          sortable: false
        },
        {
          text: this.$t('app.labels.package.shippedCarton'),
          value: 'shippedCarton',
          sortable: false
        },
        {
          text: this.$t('app.labels.package.perCartonQty'),
          value: 'perCartonQty',
          sortable: false
        }
      ],
      shipment: {},
      form: {},
      status: [
        { text: 'PO变更', value: 'CONFLICT' },
        { text: 'PO取消', value: 'CANCEL' }
      ],
      show: false,
      resolve: null,
      reject: null,
      selected: []
    }
  },
  methods: {
    params() {
      return {
        params: this.form
      }
    },
    remove() {
      this.shipment.packages = this.shipment.packages.filter(
        p => this.selected.indexOf(p) === -1
      )
    },
    save() {
      this.$http
        .put(
          `/shipping-advices/${this.shipment.id}/mock-conflict`,
          this.shipment
        )
        .then(() => {
          this.show = false
        })
    },
    popup(item) {
      this.sa = { ...item }
      this.show = true
    },
    cancel() {
      this.show = false
    }
  },
  watch: {
    sa() {
      if (this.sa) {
        this.$http.get(`/shipping-advices/${this.sa.id}`).then(res => {
          this.shipment = { ...res.data }
        })
      }
    }
  },
  computed: {
    displayHeaders() {
      return this.headers.filter(
        h =>
          this.isSeaFcl || 'containerNo,containerSize'.indexOf(h.value) === -1
      )
    },
    editable() {
      return this.shipment.status == 'SA一時保存' ||
        this.shipment.status == null
        ? true
        : false
    },
    isSeaFcl() {
      return this.isSea && this.isFcl
    },
    isSea() {
      return this.$isSea(this.shipment.transportModeId)
    },
    isAir() {
      return this.$isAir(this.shipment.transportModeId)
    },
    isFcl() {
      return this.shipment.stackTypeId == 'STACK_TYPE-FCL'
    },
    isLcl() {
      return this.shipment.stackTypeId == 'STACK_TYPE-LCL'
    }
  }
}
</script>
